import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';

@Component({
  selector: 'app-settings-page-header',
  imports: [A11yModule, IconComponent],
  templateUrl: './settings-page-header.component.html',
  styleUrl: './settings-page-header.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsPageHeaderComponent {
  /*
   * Named `heading`, not `title`: a static `title="Account"` on the host would also be written to
   * the element as the native attribute and hang a tooltip over the whole header.
   */
  public readonly heading = input.required<string>();
  public readonly subtitle = input<string>('');
  public readonly backLabel = input<string>('');
  public readonly actionLabel = input<string>('');
  public readonly actionDisabled = input<boolean>(false);
  public readonly titleId = input.required<string>();
  public readonly actionPressed = output<void>();
  public readonly closeWindow = output<void>();
  public readonly goBack = output<void>();
}
